
import React, { useEffect, useState } from 'react';
import './tooltip.css';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';


export default function List({PopupID="", setIsEdit, setEditId}) {
    const store_data = JSON.parse(store());
    const [Taxes, setTaxes] = useState([]);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchTaxes = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/taxes/list", {...filter, user: store_data});
        if (response?.status == 1) {
            setTaxes(response?.data);
        } else {
            setTaxes([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                fetchTaxes();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "Taxes", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "Taxes", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "Taxes", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "Taxes", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "Taxes", "TOGGLE_STATUS");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                
                if (viewAllowed) {
                    fetchTaxes();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/taxes/toggle-status", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/taxes/remove", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Tax setting removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    return (
        <>
            <table className="table card-table">
                <thead>
                    <tr>
                        <th>Tax Name</th>
                        <th>Charge Type</th>
                        <th>Charge Value</th>
                        <th>Tax Type</th>
                        <th style={{width: '100px'}}>Status</th>
                        <th style={{width: '160px'}}>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : Taxes && Taxes.length > 0 ?
                            Taxes?.map((val, index) => (
                                <tr key={val?.id || index}>
                                    <td>{val?.tax_name}</td>
                                    <td>{val?.charge_type}</td>
                                    <td>{val?.charge_value}</td>
                                    <td>{val?.tax_type}</td>
                                    <td>
                                        {canToggleStatus ? (
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer custom-tooltip`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>
                                                {val?.status === 1 ? 'Active' : 'Inactive'}
                                                <span className="tooltip-text">Toggle Status</span>
                                            </span>
                                        ) : (
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1`}>
                                                {val?.status === 1 ? 'Active' : 'Inactive'}
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        {canEdit && (
                                            <span className="badge bg-label-primary me-1 custom-tooltip" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}>
                                                <i className="fa fa-pen"></i>
                                                <span className="tooltip-text">Edit Tax</span>
                                            </span>
                                        )}
                                        {canDelete && (
                                            <span className="badge bg-label-danger me-1 cursor-pointer custom-tooltip"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            >
                                                <i className="fa fa-trash"></i>
                                                <span className="tooltip-text">Delete Tax</span>
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
